import { render, staticRenderFns } from "./WorkflowEditor.vue?vue&type=template&id=15032aed&scoped=true"
import script from "./WorkflowEditor.vue?vue&type=script&lang=js"
export * from "./WorkflowEditor.vue?vue&type=script&lang=js"
import style0 from "./WorkflowEditor.vue?vue&type=style&index=0&id=15032aed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15032aed",
  null
  
)

export default component.exports